import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useServiceWorkerUpdate, useUpdatePromptStore } from './useServiceWorkerUpdate';

/* Fixed bottom banner, mounted once at the app root (see App.tsx). zIndex sits above the shell's
   bottom tab bar (1200) but below the full-viewport takeovers — map fullscreen (1500) and the
   chat image-zoom overlay (1400) — so a deploy landing mid-map-view doesn't fight the map's own
   exit control for the user's attention. */
const Z_INDEX = 1300;

export function UpdateToast() {
  useServiceWorkerUpdate();
  const { t } = useTranslation();
  const needsReload = useUpdatePromptStore((s) => s.needsReload);
  const dismiss = useUpdatePromptStore((s) => s.dismiss);

  if (!needsReload) return null;

  return (
    <Box
      position="fixed"
      insetInline="0"
      bottom="0"
      display="flex"
      justifyContent="center"
      zIndex={Z_INDEX}
      pointerEvents="none"
      px="4"
    >
      <Box
        pointerEvents="auto"
        mb="max(1rem, env(safe-area-inset-bottom))"
        bg="bg.panel"
        borderWidth="1px"
        borderColor="border"
        rounded="lg"
        shadow="lg"
        px="4"
        py="3"
        maxW="sm"
        w="full"
      >
        <Flex align="center" justify="space-between" gap="3">
          <Text fontSize="sm" fontWeight="medium">
            {t('pwa_update.available')}
          </Text>
          <Flex gap="2" flexShrink={0}>
            <Button size="xs" variant="outline" onClick={dismiss}>
              {t('pwa_update.later')}
            </Button>
            <Button size="xs" colorPalette="brand" onClick={() => window.location.reload()}>
              {t('pwa_update.reload')}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
}
